<template>
  <div class="fixed w-100vw h-100vh z-60 bg-white">
    <div class="absolute top-0 right-0 mt-20 mr-16 z-50">
      <button class="text-18 px-6 py-2 focus:outline-none" @click="toggle">
        <i class="far fa-times"></i>
      </button>
    </div>

    <div class="image-container flex overflow-hidden">
      <button v-if="hasNext" @click="next" class="z-50 absolute right-0 bg-orange px-8 py-6 rounded-full center-y mr-10 text-16 focus:outline-none">
        <i class="fas fa-arrow-right text-white"></i>
      </button>

      <button v-if="hasPrevious" @click="previous" class="z-50 absolute bg-orange px-8 py-6 rounded-full left-0 center-y ml-10 text-16 focus:outline-none">
        <i class="fas fa-arrow-left text-white"></i>
      </button>

      <img :src="artwork.full_image.md"
           :alt="artwork.alt_image"
           class="object-contain w-full">
    </div>

    <div class="description-container flex flex-col justify-between py-18 px-10 border-t border-gray">
      <div>
        <a :href="artwork.url" class="block">
          <h1 class="text-orange text-20 mb-10 font-bold">
            {{ artwork.title }}
          </h1>
        </a>

        <a :href="artwork.artist.data.url" class="underline text-18 text-black block mb-10 font-bold">
          {{ artwork.artist.data.name }}
        </a>

        <p class="text-16 font-bold">
          {{ artwork.price_with_currency }}
        </p>
      </div>

      <div>
        <div class="flex mb-20">
          <i class="fas fa-calendar-alt mr-12"></i> {{ artwork.year_made }}
        </div>

        <div class="flex mb-20">
          <img :src="dimensionIcon" alt="Drybrush Dimension Icon" class="w-16 h-16 mr-12">
          <artwork-dimension
            is-text
            :depth="artwork.depth"
            :width="artwork.width"
            :height="artwork.height">
          </artwork-dimension>
        </div>

        <div class="flex">
          <i class="fas fa-paint-brush-alt mr-12"></i> {{ artwork.medium_description }}
        </div>
      </div>

      <div class="block w-full">
        <div class="mb-18">
          <add-to-cart-button :artwork="artwork" :status="artworkStatus"></add-to-cart-button>
        </div>

        <div class="w-full text-center">
          <favorite-button is-text :artwork="artwork"></favorite-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArtworkSlideShow from "../../../mixins/artworkSlideShow";
import ArtworkDimension from "../../Universal/ArtworkDimension.vue";

export default {
  name: "MobileSlideShow",

  mixins: [ArtworkSlideShow],

  components: {
    ArtworkDimension
  },
}
</script>

<style scoped>
.image-container {
  bottom: 340px;
  top: 0;
  width: 100%;
  position: absolute;
}

.description-container {
  height: 340px;
  width: 100%;
  bottom: 0;
  position: absolute;
}
</style>

